<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner">
				<el-carousel height="650px">
					<el-carousel-item>
						<img src="../images/banner_01.png" alt="" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../images/banner_01.png" alt="" />
					</el-carousel-item>
				</el-carousel>
			</div>

			<div class="bg">
				<div class="about_index">
					<div class="content">
						<div class="l">
							<div class="title">
								<span>关于我们</span>
								<strong>About US</strong>
							</div>
							<div class="text">
                                山东中喆德元智能装备有限公司总部坐落于泰安市，在潍坊、德州、沈阳均有分公司。主要生产基地在沈阳，设有研发、试验、国家级检测平台。主要从事
								<strong>自励三相异步电动机、本体激励电动机</strong>
                                的研发、生产，成立了高效节能电动机工程技术研究中心、节能电机市场中心，该项目已入选山东省新旧动能转换重大项目库优选项目
							</div>

							<a class="more" href="/about" target="_blank">
								<i class="icon el-icon-arrow-right"></i>
								了解更多
							</a>
						</div>
					</div>
					<div class="img"></div>
				</div>
			</div>

			<div class="bg_certificate">
				<div class="title">
					<span>专利认证</span>
					<p>实用新型发明专利20余项，全系列一级能效证书认证</p>
				</div>
				<a class="more" href="/about">
					<i class="icon el-icon-arrow-right"></i>
					了解更多
				</a>
			</div>

			<div class="title_01 mt70">技术创新</div>
			<div class="bg_innovation">
				<div class="content">
					<div class="left">
						<h2>本体激励电机特点</h2>
						<ul>
							<li class="i1">高效率</li>
							<li class="i1">高功率因数</li>
							<li class="i1">高精控</li>
							<li class="i1">高稳定性</li>
							<li class="i2">低电流</li>
							<li class="i2">低污染</li>
							<li class="i2">低噪音</li>
							<li class="i2">低温升</li>
						</ul>
						<a class="more" href="/innovation" target="_blank">
							<i class="icon el-icon-arrow-right"></i>
						</a>
					</div>
				</div>
				<div class="right">
					<h3>控制系统解析</h3>
					<ul>
						<li class="i1">边界扫描技术</li>
						<li class="i1">回旋抗电流产生技术</li>
						<li class="i1">电荷泵陈列技术</li>
						<li class="i1">起动冲击节能</li>
					</ul>
					<a class="more" href="/innovation" target="_blank">
						<i class="icon el-icon-arrow-right"></i>
					</a>
				</div>
			</div>

			<div class="title_01 mt70">应用案例</div>
			<ul class="case_block">
				<li>
					<strong>DRAUGHT FAN</strong>
					<span>风机类</span>
					<em>CASE</em>
					<div class="cover">
						<p>22~160kW</p>
						<p>综合节电率15%~70%</p>
						<a href="/case?type=1" target="_blank">查看详情</a>
					</div>
				</li>
				<li>
					<strong>PUMP</strong>
					<span>泵类</span>
					<em>CASE</em>
					<div class="cover">
						<p>22~160kW</p>
						<p>综合节电率15%~70%</p>
						<a href="/case?type=2" target="_blank">查看详情</a>
					</div>
				</li>
				<li>
					<strong>CONCRETE MINXER</strong>
					<span>搅拌类</span>
					<em>CASE</em>
					<div class="cover">
						<p>22~160kW</p>
						<p>综合节电率15%~70%</p>
						<a href="/case?type=3" target="_blank">查看详情</a>
					</div>
				</li>
				<li>
					<strong>MILLING MACHINE</strong>
					<span>磨机类</span>
					<em>CASE</em>
					<div class="cover">
						<p>22~160kW</p>
						<p>综合节电率15%~70%</p>
						<a href="/case?type=4" target="_blank">查看详情</a>
					</div>
				</li>
			</ul>

			<div class="title_01 mt70">新闻中心</div>
			<div class="content">
				<ul class="news_list mt40">
					<li>
						<img src="../images/news/zhongshihua.jpeg" alt="" style="width: 433px;height: 312px;box-shadow: 2px 2px 2px 2px rgba(0,0,0,0.5);"/>
						<span>2022.08.19</span>
						<p>我司进入中石化供应商体系</p>
						<a class="more" href="/detail1" target="_blank">
							<i class="icon el-icon-arrow-right"></i>
							了解更多
						</a>
					</li>
					<li>
						<img src="../images/news/yunpingtai.png" alt="" style="width: 433px;height: 312px;box-shadow: 2px 2px 2px 2px rgba(0,0,0,0.5);"/>
						<span>2023.05.20</span>
						<p>中喆德元电机云平台上线</p>
						<a class="more" href="/detail2" target="_blank">
							<i class="icon el-icon-arrow-right"></i>
							了解更多
						</a>
					</li>
<!--					<li>-->
<!--						<img src="../images/img/img_01.png" alt="" />-->
<!--						<span>2022.08.19</span>-->
<!--						<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--						<a class="more" href="" target="_blank">-->
<!--							<i class="icon el-icon-arrow-right"></i>-->
<!--							了解更多-->
<!--						</a>-->
<!--					</li>-->
				</ul>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
	data() {
		return {}
	},
	components: {
		Header,
		Footer
	}
}
</script>

<style lang="less" scoped>
.about_index {
	width: 100%;
	display: flex;
	position: relative;

	.l {
		width: 690px;
		height: 525px;
		padding-right: 50px;
		flex-shrink: 0;

		.title {
			position: relative;
			padding-bottom: 70px;
			margin-top: 30px;
			span {
				font-size: 38px;
			}
			strong {
				font-size: 60px;
				line-height: 60px;
				opacity: 0.1;
				position: absolute;
				left: 0;
				bottom: 0px;
			}
		}
		.text {
			color: #000;
			font-size: 20px;
			line-height: 40px;
			margin-top: 40px;

			strong {
				color: #1265a4;
			}
		}
		.more {
			color: #1265a4;
			font-size: 16px;
			margin-top: 70px;
			display: flex;
			align-items: center;

			.icon {
				color: #fff;
				font-size: 20px;
				width: 40px;
				height: 40px;
				border-radius: 40px;
				background: #1265a4;
				margin-right: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}
	.img {
		width: 50%;
		height: 525px;
		background: url('../images/img_01.png') left no-repeat;
		position: absolute;
		top: 0;
		right: 0;
	}
}

.bg_certificate {
	width: 100%;
	height: 800px;
	background: url('../images/bg_01.png') center no-repeat;
	padding-top: 80px;
	position: relative;

	.title {
		color: #fff;
		width: 100%;
		text-align: center;

		span {
			font-size: 38px;
		}
		p {
			font-size: 36px;
			font-weight: bold;
			margin-top: 25px;
		}
	}
	.more {
		color: #0052a1;
		font-size: 16px;
		width: 240px;
		height: 70px;
		background: #fff;
		border-radius: 70px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		left: 50%;
		bottom: 50px;
		transform: translate(-50%, 0);

		.icon {
			color: #fff;
			font-size: 20px;
			width: 40px;
			height: 40px;
			border-radius: 40px;
			background: #1265a4;
			margin-right: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
}
.bg_innovation {
	width: 100%;
	max-width: 1920px;
	min-width: 1380px;
	height: 550px;
	margin: 40px 0 auto;
	background: #f6f6f6;
	position: relative;

	.left {
		width: 690px;
		padding-top: 85px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.right {
		width: 50%;
		height: 550px;
		background: #f6f6f6 url('../images/bg_02.png') left no-repeat;
		position: absolute;
		top: 0;
		right: 0;
		padding-top: 85px;
		display: flex;
		flex-direction: column;
		align-items: center;

		ul {
			width: 420px;
			padding: 0;
			li {
				width: 200px;
			}
		}
	}
	h2 {
		color: #333;
		font-size: 30px;
		padding-top: 75px;
		background: url('../images/ico_01.png') top no-repeat;
	}
	h3 {
		color: #333;
		font-size: 30px;
		padding-top: 75px;
		background: url('../images/ico_02.png') top no-repeat;
	}
	ul {
		width: 100%;
		padding: 0 35px;
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		li {
			color: #0052a1;
			width: 140px;
			height: 44px;
			line-height: 42px;
			border: 1px solid #e9e9e9;
			padding: 0 20px;
			margin-top: 20px;

			&.i1 {
				background: #fff url('../images/ico_03.png') 90% no-repeat;
			}
			&.i2 {
				background: #fff url('../images/ico_04.png') 90% no-repeat;
			}
		}
	}
	.more {
		color: #666;
		font-size: 20px;
		width: 40px;
		height: 40px;
		border-radius: 40px;
		border: 1px solid #aaaaaa;
		margin-top: 75px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.case_block {
	width: 100%;
	height: 550px;
	background: url('../images/bg_03.png') center no-repeat;
	margin-top: 45px;
	display: flex;

	li {
		color: #fff;
		width: 25%;
		border-right: 1px solid #fff;
		padding-top: 180px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		strong {
			font-size: 40px;
			position: relative;
			z-index: 2;
			&:after {
				content: '';
				width: 50px;
				height: 3px;
				background: rgba(255, 255, 255, 0.3);
				position: absolute;
				left: 50%;
				top: 70px;
				transform: translate(-50%, 0);
			}
		}
		span {
			font-size: 26px;
			position: absolute;
			left: 50%;
			top: 280px;
			transform: translate(-50%, 0);
			z-index: 2;
		}
		em {
			font-style: normal;
			opacity: 0.5;
			position: absolute;
			left: 50%;
			bottom: 20px;
			transform: translate(-50%, 0);
			z-index: 2;
		}

		.cover {
			font-size: 16px;
			text-align: center;
			width: 100%;
			height: 100%;
			line-height: 30px;
			background: rgba(0, 82, 161, 0.8);
			padding-top: 335px;
			position: absolute;
			left: 0;
			top: 0;
			display: none;

			a {
				color: #fff;
				text-align: center;
				width: 110px;
				height: 32px;
				line-gap-override: 30px;
				border: 1px solid #fff;
				border-radius: 32px;
				display: inline-block;
				margin-top: 35px;
			}
		}

		&:hover {
			.cover {
				display: block;
			}
		}
	}
}

.news_list {
	width: 100%;
	display: flex;

	li {
		width: 435px;
		margin-right: calc(75px / 2);
		display: flex;
		flex-direction: column;

		&:last-child {
			margin-right: 0;
		}

		img {
			width: 435px;
			height: 310px;
			border-radius: 15px;
			object-fit: cover;
		}
		span {
			color: #666;
			font-size: 16px;
			margin-top: 30px;
		}
		p {
			width: 100%;
			font-size: 24px;
			height: 56px;
			line-height: 28px;
			margin-top: 20px;
			overflow: hidden;
		}
		.more {
			color: #1265a4;
			font-size: 16px;
			margin-top: 30px;
			display: flex;
			align-items: center;

			.icon {
				color: #fff;
				font-size: 14px;
				width: 20px;
				height: 20px;
				border-radius: 20px;
				background: #1265a4;
				margin-right: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}
}
</style>
